module.exports = __webpack_public_path__ + "img/magnify-graph.4acad423.png";